import React, { useEffect, useMemo, useState } from "react";
import classNames from "classnames";
// import { SellerProfile } from "../../../stores/seller-store/seller-store.model";
import { getAllColors, getRGBColor } from "@/utils/color";
import { SellerProfile } from "@/stores/seller-store/seller-store.model";
import { BottomNav } from "./bottom-nav";
import { AppHeader } from "./app-header";

interface MobileContainerProps {
  sellerData?: SellerProfile;
  children: React.ReactNode;
  title?: string;
  RightComponent?: React.ReactNode;
  bottomNavigation?: boolean;
  backNavigation?: boolean;
  fixedHeader?: boolean;
  headerClassName?: string;
  containerClassName?: string;
  containerStyle?: React.CSSProperties;
  onBackClick?: () => void;
}

export const MobileContainer: React.FunctionComponent<MobileContainerProps> = ({
  sellerData,
  children,
  bottomNavigation,
  backNavigation,
  title,
  RightComponent,
  fixedHeader,
  containerClassName,
  headerClassName,
  onBackClick,
}) => {
  const primaryColor = useMemo(() => getAllColors(sellerData?.landing_setting?.appearanceSetting?.mainColor ?? "#b20404", "primary"), [sellerData?.landing_setting?.appearanceSetting?.mainColor])
  // const secondaryColor = useMemo(() => getRGBColor(sellerData?.landing_setting?.appearanceSetting?.secondaryColor ?? "#000000", "", '-'), [sellerData?.landing_setting?.appearanceSetting?.secondaryColor])
  const defaultTextColor = useMemo(() => getRGBColor(sellerData?.landing_setting?.appearanceSetting?.mainTextColor ?? "#000000", "default", 'text-color'), [sellerData?.landing_setting?.appearanceSetting?.mainTextColor])
  const defaultBgColor = useMemo(() => getAllColors(sellerData?.landing_setting?.appearanceSetting?.mainBgColor ?? "#fff", "custombg"), [sellerData?.landing_setting?.appearanceSetting?.mainBgColor])

  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <>
      {isClient && <style>
        .mobile-container {`{${primaryColor} ${defaultTextColor} ${defaultBgColor} color: rgba(var(--text-color-default)) !important; }`}
        .ReactModalPortal {`{${primaryColor} ${defaultTextColor} ${defaultBgColor}}`}
        .text-black {"{color: rgba(var(--text-color-default)) !important;}"}
        input {"{color: #000000 !important; background-color: #ffffff !important;}"}
        #checkboxpath {"{stroke: rgba(var(--color-custombg-500));}"}
      </style>}
      <div className={classNames("w-[100vw] h-[100vh] flex flex-col items-center overflow-x-hidden overflow-y-scroll mobile-container",
        containerClassName,
        { "min-h-screen": fixedHeader }
      )}
        style={{ backgroundColor: sellerData?.landing_setting?.appearanceSetting?.mainBgColor }}
      >

        {!!(backNavigation || title || RightComponent) && (
          <AppHeader
            headerClassName={headerClassName}
            onBackClick={onBackClick}
            title={title}
            fixedHeader={fixedHeader}
            RightComponent={RightComponent}
            backNavigation={backNavigation}
          />
        )}
        <div className="flex flex-col w-full sm:max-w-screen-mobile">
          {children}
        </div>
        {bottomNavigation && <BottomNav />}
      </div>
    </>
  );
};
